import {
  FETCH_CONFIG_SUCCESS,
  FETCH_PUBLIC_CONFIG_SUCCESS,
  FETCH_CONFIG_UPDATE_SUCCESS,
  FETCH_CONFIG_ERROR,
  FETCH_PUBLIC_CONFIG_ERROR
} from '@components/config/constants';

const initialState = {
  siteError: false,
  siteLoaded: false,
  userLoaded: false,
  publicSiteError: false,
  publicConfig: null
};

const configReducer = (state = initialState, action) => {
  switch (action.type) {
  case FETCH_CONFIG_SUCCESS: {
    return {
      ...state,
      ...action.config,
      siteLoaded: true
    };
  }
  case FETCH_PUBLIC_CONFIG_SUCCESS: {
    return {
      ...state,
      publicConfig: action.config
    };
  }
  // A config update was received, it brings all the configuration
  // settings that gets filled after the user is
  // authenticated.
  case FETCH_CONFIG_UPDATE_SUCCESS: {
    return {
      ...state,
      ...action.config,
      userLoaded: true
    };
  }
  case FETCH_CONFIG_ERROR: {
    return {
      ...state,
      siteError: true
    };
  }
  case FETCH_PUBLIC_CONFIG_ERROR: {

    return {
      ...state,
      publicSiteError: true
    };
  }
  default:
    return state;
  }
};

export default configReducer;
